export default __webpack_public_path__ + "static/media/folder.f65f72d2.svg";